// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import { AbymeController } from 'abyme';
application.register('abyme', AbymeController);

import AddQuestionController from "./addquestion_controller"
application.register("addquestion", AddQuestionController)
